import { render, staticRenderFns } from "./ModalInsercaoArquivoVetorial.vue?vue&type=template&id=3b7ae686&lang=pug"
import script from "./ModalInsercaoArquivoVetorial.vue?vue&type=script&lang=js"
export * from "./ModalInsercaoArquivoVetorial.vue?vue&type=script&lang=js"
import style0 from "./ModalInsercaoArquivoVetorial.vue?vue&type=style&index=0&id=3b7ae686&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports